// src/components/Footer.js
import React from "react";
import { Link } from "react-router-dom";
import { FaInstagram, FaLinkedin, FaFacebook, FaGlobe } from "react-icons/fa";

export default function Footer() {
  return (
    <footer className="footer">
      <div className="footer-inner">
        {/* Col 1 */}
        <div className="footer-col">
          <p className="footer-brand">
            <strong>Maxime H</strong>
            <br />
            Photographe culinaire — restaurants, chefs & marques
          </p>
          <p className="footer-note">
            Basé à Tomblaine / Nancy — déplacements France • Belgique • Luxembourg
          </p>
        </div>

        {/* Col 2 */}
        <div className="footer-col">
          <p className="footer-title">Contact</p>
          <p className="footer-linkline">
            <a className="footer-link" href="mailto:contact@maximeh.fr">contact@maximeh.fr</a>
          </p>
          <p className="footer-note">Réponse sous 24–48h (hors week-end)</p>
        </div>

        {/* Col 3 */}
        <div className="footer-col footer-col-right">
          <p className="footer-title">Me suivre</p>
          <div className="footer-socials">
            <a href="https://www.maximeh.fr" target="_blank" rel="noreferrer" aria-label="Site">
              <FaGlobe />
            </a>
            <a href="https://www.instagram.com/maximehphoto" target="_blank" rel="noreferrer" aria-label="Instagram">
              <FaInstagram />
            </a>
            <a href="https://www.linkedin.com/in/maximehculinaire/" target="_blank" rel="noreferrer" aria-label="LinkedIn">
              <FaLinkedin />
            </a>
            <a href="https://www.facebook.com/maximehculinaire" target="_blank" rel="noreferrer" aria-label="Facebook">
              <FaFacebook />
            </a>
          </div>
        </div>
      </div>

      {/* barre du bas */}
      <div className="footer-bottom">
        <p>© {new Date().getFullYear()} Maxime HUYLEBROECK EI — Tous droits réservés</p>

        <div className="footer-legal">
          <Link className="footer-legal-link" to="/mentions-legales">Mentions légales</Link>
          <span className="footer-sep">·</span>
          <Link className="footer-legal-link" to="/confidentialite">Confidentialité</Link>
          <span className="footer-sep">·</span>
          <Link className="footer-legal-link" to="/cgv">Conditions Générales de Vente</Link>
        </div>
      </div>
    </footer>
  );
}